/* Moved out of sections/main-nav.liquid (was an inline <script> there), loaded with defer. */
  /* Mobile full-screen search overlay + predictive search.
     Pure progressive enhancement — without JS the form still submits to
     /search?q=... and the trigger button does nothing. With JS:
       - Mobile: trigger button opens a full-screen search overlay;
         Cancel button / Escape / trigger closes it.
       - All viewports: typing in the input fetches predictive results
         from Shopify's /search/suggest.json and renders them (a dropdown
         on desktop, an in-flow list inside the overlay on mobile).
       - Arrow keys + Enter select results without leaving the input. */
  (function () {
    var trigger = document.querySelector('[data-search-trigger]');
    var form    = document.querySelector('[data-search-form]');
    var input   = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-predictive-results]');
    var cancel  = document.querySelector('[data-search-cancel]');
    if (!form || !input || !results) return;

    /* ── Responsive placeholder ──
       Swap to the shorter `data-mobile-placeholder` value at ≤720px
       widths. The full locale string is fine for the 560px desktop
       input but gets cut off mid-word on narrow phones. Listening on
       resize covers DevTools toggling, screen rotation, and tablet
       split-view — cheap (no DOM work unless the breakpoint flips).

       The breakpoint matches the section CSS media query above so the
       text swap happens at the same width as the panel layout change. */
    var fullPlaceholder = input.getAttribute('placeholder') || '';
    var mobilePlaceholder = input.dataset.mobilePlaceholder || fullPlaceholder;
    function syncPlaceholder() {
      input.placeholder = window.innerWidth <= 720 ? mobilePlaceholder : fullPlaceholder;
    }
    syncPlaceholder();
    var resizePlaceholderTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizePlaceholderTimer);
      resizePlaceholderTimer = setTimeout(syncPlaceholder, 120);
    });

    /* ── Mobile overlay open/close ── */
    function openPanel() {
      form.classList.add('is-open');
      document.body.classList.add('is-search-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      /* Wait for the fade-in to start before focusing so the keyboard
         doesn't pop up mid-transition (which jumps the layout on iOS). */
      setTimeout(function () { input.focus(); }, 120);
    }
    function closePanel() {
      form.classList.remove('is-open');
      document.body.classList.remove('is-search-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      /* Drop the soft keyboard on close — without an explicit blur the
         keyboard can linger on iOS after the overlay fades out. */
      input.blur();
      hideResults();
    }
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (form.classList.contains('is-open')) closePanel();
        else openPanel();
      });
    }
    /* Cancel button — overlay-only, returns focus to the trigger so a
       keyboard / screen-reader user lands back where they started. */
    if (cancel) {
      cancel.addEventListener('click', function () {
        closePanel();
        if (trigger) trigger.focus();
      });
    }

    /* ── Outside click + Escape ──
       On desktop the overlay never opens, so this just dismisses the
       predictive dropdown when the user clicks away from the form. On
       mobile the overlay covers the viewport, so an "outside" click
       can't happen while it's open — Cancel / Escape handle that. */
    document.addEventListener('click', function (e) {
      if (form.contains(e.target)) return;
      if (trigger && trigger.contains(e.target)) return;
      hideResults();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (form.classList.contains('is-open')) {
        closePanel();
        if (trigger) trigger.focus();
      } else if (!results.hidden) {
        hideResults();
      }
    });

    /* ── Predictive search ──
       Hits Shopify's built-in /search/suggest.json endpoint. Debounced
       at 220ms so each keystroke doesn't fire a request. Minimum 2
       chars to avoid flooding the endpoint with single-letter queries.

       Returned `price` from Shopify is a string in the major currency
       unit (e.g. "9.99") that represents the ex-VAT stored value (Shopify
       Tax setting: "All prices include tax" is OFF on this store). We
       multiply by 1.2 to display the inc-VAT figure that matches the
       headline pricing everywhere else on the site. */
    var debounceTimer;
    var lastQuery = '';
    var requestSeq = 0;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { hideResults(); lastQuery = ''; return; }
      if (q === lastQuery) return;
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 220);
    });

    function fetchSuggestions(query) {
      lastQuery = query;
      var seq = ++requestSeq;
      var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search/suggest.json?q=' + encodeURIComponent(query) +
                '&resources[type]=product,collection,article' +
                '&resources[limit]=5' +
                '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          /* Out-of-order guard: only render the most recent request's
             results. Without this, a slow earlier response can overwrite
             a faster later one and show stale matches. */
          if (seq !== requestSeq) return;
          renderResults(data, query);
        })
        .catch(function () {
          if (seq === requestSeq) hideResults();
        });
    }

    function renderResults(data, query) {
      var r = (data && data.resources && data.resources.results) || {};
      var products    = r.products    || [];
      var collections = r.collections || [];
      var articles    = r.articles    || [];

      var html = '';

      if (products.length) {
        html += '<div class="main-nav__predictive-section">';
        html += '<div class="main-nav__predictive-section-title">Products</div>';
        html += products.map(function (p) {
          var img = p.image
            ? '<img src="' + escapeAttr(p.image) + '" alt="" loading="lazy">'
            : '';
          var price = formatPrice(p.price);
          return '<a href="' + escapeAttr(p.url) + '" class="main-nav__predictive-item" role="option">' +
            '<div class="main-nav__predictive-item-img">' + img + '</div>' +
            '<div class="main-nav__predictive-item-info">' +
              '<div class="main-nav__predictive-item-title">' + escapeHtml(p.title) + '</div>' +
              (price ? '<div class="main-nav__predictive-item-meta">' + price + '</div>' : '') +
            '</div></a>';
        }).join('');
        html += '</div>';
      }

      if (collections.length) {
        html += '<div class="main-nav__predictive-section">';
        html += '<div class="main-nav__predictive-section-title">Categories</div>';
        html += collections.map(function (c) {
          return '<a href="' + escapeAttr(c.url) + '" class="main-nav__predictive-item" role="option">' +
            '<div class="main-nav__predictive-item-info">' +
              '<div class="main-nav__predictive-item-title">' + escapeHtml(c.title) + '</div>' +
            '</div></a>';
        }).join('');
        html += '</div>';
      }

      if (articles.length) {
        html += '<div class="main-nav__predictive-section">';
        html += '<div class="main-nav__predictive-section-title">Articles</div>';
        html += articles.map(function (a) {
          return '<a href="' + escapeAttr(a.url) + '" class="main-nav__predictive-item" role="option">' +
            '<div class="main-nav__predictive-item-info">' +
              '<div class="main-nav__predictive-item-title">' + escapeHtml(a.title) + '</div>' +
            '</div></a>';
        }).join('');
        html += '</div>';
      }

      if (!html) {
        html = '<div class="main-nav__predictive-empty">No matches for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
      } else {
        /* Always offer the full search page as a fallback below the
           top-5 hits, in case the customer wants the complete result
           set rather than the predictive subset. */
        html += '<div class="main-nav__predictive-footer">' +
          '<a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search?q=' + encodeURIComponent(query) + '">View all results for &ldquo;' + escapeHtml(query) + '&rdquo; →</a>' +
          '</div>';
      }

      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function hideResults() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      clearActive();
    }

    /* ── Price formatting ──
       Shopify returns price as a string like "9.99" or "9999" (varies
       between stores / Shopify versions). Detect format by checking for
       a decimal point: with → already major units; without → cents.
       Then multiply by 1.2 for the inc-VAT headline, with the ex-VAT
       figure small beside it as everywhere else on the site. */
    function formatPrice(raw) {
      if (raw === null || raw === undefined || raw === '') return '';
      var num = parseFloat(String(raw).replace(/[^\d.]/g, ''));
      if (isNaN(num) || num <= 0) return '';
      if (String(raw).indexOf('.') === -1 && num >= 100) num = num / 100;
      var inc = num * ((window.theme && window.theme.market && window.theme.market.vatRate) || 1.2);
      return '<span class="main-nav__predictive-price">' + pounds(inc) + '</span>' +
        '<span class="main-nav__predictive-price-ex">' + pounds(num) + ' (Exc VAT)</span>';
    }
    /* £1,189.00, with the thousands comma the rest of the site uses. */
    function pounds(n) {
      if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(Math.round(n * 100));
      return '£' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    /* ── HTML / attr escaping ──
       Defensive against malicious product titles. textContent + innerHTML
       round-trip handles all HTML-significant chars. Attribute escaping
       is the same trick but stricter (encode quote too). */
    function escapeHtml(str) {
      var d = document.createElement('div');
      d.textContent = String(str == null ? '' : str);
      return d.innerHTML;
    }
    function escapeAttr(str) {
      return escapeHtml(str).replace(/"/g, '&quot;');
    }

    /* ── Keyboard navigation through results ── */
    var activeIdx = -1;
    input.addEventListener('keydown', function (e) {
      if (results.hidden) return;
      var items = results.querySelectorAll('.main-nav__predictive-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIdx = (activeIdx + 1) % items.length;
        applyActive(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIdx = activeIdx <= 0 ? items.length - 1 : activeIdx - 1;
        applyActive(items);
      } else if (e.key === 'Enter' && activeIdx > -1) {
        e.preventDefault();
        window.location.href = items[activeIdx].href;
      }
    });
    function applyActive(items) {
      items.forEach(function (it, n) { it.classList.toggle('is-active', n === activeIdx); });
      if (activeIdx > -1) items[activeIdx].scrollIntoView({ block: 'nearest' });
    }
    function clearActive() { activeIdx = -1; }
    /* Reset cursor when input changes — prevents Enter from triggering
       a stale highlighted item after the user edits their query. */
    input.addEventListener('input', clearActive);
  })();
